/* ADD GROUPS */
export const LIST_QUESTIONS = "LIST_QUESTIONS"
export const LIST_QUESTIONS_SUCCESS = "LIST_QUESTIONS_SUCCESS"
export const LIST_QUESTIONS_CLEAN = "LIST_QUESTIONS_CLEAN"
export const LIST_QUESTIONS_ERROR = "LIST_QUESTIONS_ERROR"
